/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';

import { Button, Text, Space } from '@cashfree-intl/coherent';
import CustomIcon from 'components/CustomIcons';
import { titleCase } from 'utils/common';

const Confirmation = ({
  closeModal,
  decrementStep,
  onConfirm,
  loading,
  modeDetails,
}) => (
  <>
    <div className="navigate-back" onClick={decrementStep}>
      <CustomIcon componentName="CHEVRONDOWN" direction="up" />
      Back
    </div>
    <Space gap={2} direction="column">
      <Text variant="b14" color="bodyLight">
        <span className="text-dark w-600">
          {titleCase(modeDetails.display)}
        </span>{' '}
        payment mode activation usually takes{' '}
        <span className="text-dark w-600">
          {modeDetails.activationTime.toLowerCase()}
        </span>
        . A standard pricing of{' '}
        <span className="text-dark w-600">{modeDetails.standardPricing}</span>{' '}
        is applicable per transaction.
      </Text>
      <div className="text-right cta-wrapper">
        <Button
          type="button"
          link
          className="link"
          onClick={closeModal}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          primary
          onClick={onConfirm}
          loading={loading}
          disabled={loading}
        >
          Confirm
        </Button>
      </div>
    </Space>
  </>
);

Confirmation.propTypes = {
  closeModal: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  decrementStep: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  modeDetails: PropTypes.object.isRequired,
};

export default Confirmation;
